import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getCurrentCooperationCompany, isCooperationCompanyLoading } from 'redux/query';
import { useEffect, useMemo, useState } from 'react';
import { clearInsuranceCompany, getInsuranceCompanyBySlugRequest } from 'redux/actions';

export const useGetHealthInsuranceCooperation = ({ cooperation, course } = {}, deps = []) => {
  const dispatch = useDispatch();
  const { cooperation: _cooperation, course: _course } = useParams();
  const [requested, setRequested] = useState(false);

  const _cooperationCompany = useSelector(getCurrentCooperationCompany);
  const isLoading = useSelector(isCooperationCompanyLoading);
  const cooperationSlug = cooperation || _cooperation;
  const courseSlug = course || _course;

  const cooperationCompany = useMemo(() => {
    if ((cooperationSlug && _cooperationCompany?.slug === cooperationSlug) || (!cooperationSlug && !!_cooperationCompany)) {
      return _cooperationCompany;
    }
    return null;
  }, [cooperationSlug, _cooperationCompany]);

  useEffect(() => {
    if (isLoading && !requested) {
      setRequested(true);
    }
  }, [isLoading, requested]);

  const selectedOffer = useMemo(() => {
    if (!courseSlug) {
      return null;
    }
    return cooperationCompany?.offers?.find((offer) => offer.slug === courseSlug) || null;
  }, [cooperationCompany, courseSlug, ...deps]);

  return {
    isLoading,
    cooperationCompany,
    cooperation: cooperationSlug,
    selectedOffer,
    notFound: !isLoading && !cooperationCompany && requested,
    clearInsuranceCompany: () => dispatch(clearInsuranceCompany()),
    getInsuranceCompanyBySlugRequest: (slug) => dispatch(getInsuranceCompanyBySlugRequest({ slug })),
    getInsuranceCompanyRequest: () => dispatch(getInsuranceCompanyBySlugRequest({ slug: cooperationSlug }))
  };
};
